/* tslint:disable */
/* eslint-disable */
/**
 * PanKanapka
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IsAvailableResponse
 */
export interface IsAvailableResponse {
    /**
     * 
     * @type {boolean}
     * @memberof IsAvailableResponse
     */
    isAvailable?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof IsAvailableResponse
     */
    cities?: string[];
}

export function IsAvailableResponseFromJSON(json: any): IsAvailableResponse {
    return IsAvailableResponseFromJSONTyped(json, false);
}

export function IsAvailableResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): IsAvailableResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isAvailable': !exists(json, 'isAvailable') ? undefined : json['isAvailable'],
        'cities': !exists(json, 'cities') ? undefined : json['cities'],
    };
}

export function IsAvailableResponseToJSON(value?: IsAvailableResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isAvailable': value.isAvailable,
        'cities': value.cities,
    };
}


